import i18n from 'services/base/i18n';

export default {
  // Text describing the title of the page
  passwordReset: () => i18n.pgettext('Pages|Password Reset', 'Password Reset'),

  // Text for email address
  email: () => i18n.pgettext('Pages|Password Reset', 'EMAIL ADDRESS'),

  // Text for continue button
  submit: () => i18n.pgettext('Pages|Password Reset', 'CONTINUE'),
};
